import React, { useEffect, useState, useRef } from "react";
import ReactDom from "react-dom";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";

import "./../assets/custom-modal.css";

import axios from "axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useMediaQuery } from 'react-responsive';
import MediaQuery from 'react-responsive'

import Modal from 'react-bootstrap/Modal';
import { Card } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { Rating } from "react-simple-star-rating";

import dayjs from 'dayjs'
import 'dayjs/locale/it.js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { itIT } from "@mui/x-date-pickers/locales";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import { durationsMins } from './../../constants/durationsMins.ts';

  // ---- INI --- costanti generali
  const cookie_info="Questo sito utilizza cookie tecnici (ovvero cookie necessari) e con il tuo consenso anche cookie analitici e di profilazione, che utilizzeremo noi e terze parti, rispettivamente necessari a consentire alcune funzionalità fondamentali per il sito, ad ottenere misurazioni delle performances del sito stesso e ove previsti a proporti inserzioni promozionali in linea con i tuoi interessi, come specificato nella cookie policy. Puoi liberamente accettare, rifiutare o personalizzare il tuo consenso: cliccando su ‘Accetta’ acconsenti all’utilizzo di tutti i cookie, compresi i cookie di profilazione anche di terze parti; cliccando su ‘Personalizza’ puoi confermare le tue preferenze dopo aver selezionato le finalità di tuo interesse nel box sotto-riportato, dove è possibile anche visualizzare i dettagli di ogni singola categoria di cookie; cliccando invece su ‘Chiudi e accetta solo cookie necessari’, installerai solo i cookie strettamente necessari, rifiutando di conseguenza tutte le altre tipologie (cookie di profilazione inclusi). Per maggiori informazioni puoi consultare in qualsiasi momento la cookie policy."

  
  // ----FIN --- costanti generali

  const modalAppuntamento = document.getElementById("modal-appuntamento");

  const ModalAppuntamento = props => {

  const refModal = useRef();
  const [modalOpacity, setModalOpacity] = useState(0);
  const transitionTime = 300;
  const styles = { transition: `all linear ${transitionTime}ms` };

  const [mainCategories, setMainCategories] = useState([]);

  const [validated, setValidated] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const closeModalAppuntamento = () => {
    setModalOpacity(0);
    setTimeout(() => props.closeModal(), transitionTime);
  };

  const { pageNumParam } = useParams() || 1;
  const { searchQuery } = useParams() || "";
  const [sortOption, setSortOption] = useState("");
  const [paginationLinksNumber, setPaginationLinksNumber] = useState(null);
  const [pageNum, setPageNum] = useState(null);
  const [filters, setFilters] = useState({}); // collect all filters
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attrsFilter, setAttrsFilter] = useState([]); // collect category attributes from db and show on the webpage
  const [attrsFromFilter, setAttrsFromFilter] = useState([]); // collect user filters for category attributes
  
  const [filtersUrl, setFiltersUrl] = useState([]);
  const [proceedFilters, setProceedFilters] = useState([]);

  const [rating, setRating] = useState(null);

  const {categories} = useSelector((state) => state.getCategories);
  
  const [resources, setResources] = useState([]);
  const [sites, setSites] = useState([]);

  const [siteChoosen, setSiteChoosen] = useState("Choose site");
  
  const [product, setProduct] = useState({});

  const isMobile = useMediaQuery({ query: '(min-width: 576px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 768px)' });
  const isPC = useMediaQuery({ query: '(min-width: 992px)' });
  
  const [activeTab, setActiveTab] = useState('appuntamento');
  
  // true/false se valorizzati
  const [isCategoriaScelta, setIsCategoriaScelta] = useState(false);  // è un boleano true/false
  const [isProdottoScelto, setIsProdottoScelto] = useState(false);    // è un boleano true/false
  const [isRisorsaScelta, setIsRisorsaScelta] = useState(false);      // è un boleano true/false
  const [isSitoScelto, setIsSitoScelto] = useState(false);            // è un boleano true/false
  
  // value in variazione nel Modal
  const [oraEditata, setOraEditata] = useState("");                            // è la ora cliccata nelTab

  const [oraScelta, setOraScelta] = useState("");                                 // è la ora cliccata nelTab
  const [clienteDigitato, setClienteDigitato] = useState("");                     // è la ora cliccata nelTab
  const [categoriaScelta, setCategoriaScelta] = useState("scegli la categoria");  // è la categoria cliccata nelTab
  const [prodottoScelto, setProdottoScelto] = useState("scegli il servizio");     // è il servizio/prodotto cliccata nelTab
  const [risorsaScelta, setRisorsaScelta] = useState("schegli la risorsa");       // è la ora risorsa cliccata nelTab
  const [sitoScelto, setSitoScelto] = useState("schegli il sito");                // è la il sito cliccato nelTab
  const [durataScelta, setDurataScelta] = useState("schegli la durata");          // è la la durata cliccata nelTab
  const [ownerScelto, setOwnerScelto] = useState("0000");                         // è l'owner dell'inizio ora appuntamento
  const [coloreScelto1, setColoreScelto1] = useState("scegli il colore");         // è il colore della categoria cliccata nelTab
  
  const [siteSelected, setSiteSelected] = useState();          // è il site cliccato nelTabServizio

  const [isCookiesNecessari, setIsCookiesNecessari] = useState(true);                      
  const [isCookiesFunzionali, setIsCookiesFunzionali] = useState(false);                      
  const [isCookiesAnalitici, setIsCookiesAnalitici] = useState(false);                      
  const [isCookiesProfilazione, setIsCookiesProfilazione] = useState(false);                      
   
  useEffect(() => {
    setActiveTab(1);
    setModalOpacity(1);
    const handleClick = e => {
      if (refModal.current.contains(e.target)) {
        // inside click
        return;
      }
      // outside click
      closeModalAppuntamento();
    };
    // add when rendered
    document.addEventListener("mousedown", handleClick);
    // return clean up function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);
  
  const switchCookieNecessariHandler = (event) => {
    setIsCookiesNecessari(event.target.checked);
    console.log('[switch] isCookiesNecessari =',isCookiesNecessari)
  };

  const switchCookieFunzionaliHandler = (event) => {
    setIsCookiesFunzionali(event.target.checked);
    console.log('[switch] isCookiesFunzionali =',isCookiesFunzionali)
  };

  const switchCookieAnaliticiHandler = (event) => {
    setIsCookiesAnalitici(event.target.checked);
    console.log('[switch] isCookiesAnalitici =',isCookiesAnalitici)
  };

  const switchCookieProfilazioneHandler = (event) => {
    setIsCookiesProfilazione(event.target.checked);
    console.log('[switch] isCookiesProfilazione =',isCookiesProfilazione)
  };

  return ReactDom.createPortal(
    <div >
      <div
        className={props.isOpenTabAppuntamento ? "modal fade-n show" : "modal fade-out"}
        style={
          props.isOpenTabAppuntamento
            ? { ...styles, opacity: modalOpacity, display: "block" }
            : { ...styles, opacity: modalOpacity, display: "none" }
        }
        id="exampleModal"
        tabIndex="-1"
      >

        <Modal.Dialog size="lg"
              style={
                {  }
              } 
        
        >

            <Modal.Header onClick={closeModalAppuntamento}
              style={
                { backgroundColor: '#CCE5FF', height:60, align: "center" }
              } 
            
            >

            <h3>Consenso all'utilizzo dei cookie</h3> 

            </Modal.Header>

            <Modal.Body>

            
            {/* 
            */}

                <Tabs id="uncontrolled-tab-example"                
                  className="mb-3 px-5"
                  defaultActiveKey={1}
                  activeKey={activeTab}        
                  onSelect={(key) => setActiveTab(key)}         
                >
                      
                    <Tab eventKey={1} title="Uso cookie" activeKey={2}>

                      <Box
                        component="form"
                        sx={{ '& > :not(style)': { m: 1 } }}
                        noValidate
                        autoComplete="off"
                      >
                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          { cookie_info }
                        </Typography>
                      </Box>
                    </Tab>


            {/* 
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>

                            <Box
                              component="form"
                              sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                              noValidate
                              autoComplete="off"
                            >

                              <TextField id="outlined-basic" label="Cliente" variant="outlined" defaultValue={props.cliente} 
                                onChange={(event) => {
                                  setClienteDigitato(event.target.value);
                                }}
                              />


                              <TextField id="outlined-basic" label="Risorsa" variant="outlined" defaultValue={props.titoloRisorsa} 
                                slotProps={{
                                  input: {
                                    readOnly: true,
                                  },
                                }}
                              />

 
                            </Box>

                            <Box
                              component="form"
                              sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                              noValidate
                              autoComplete="off"
                            >
 
 

                            </Box>

                        </Form>
            */}
        

                    <Tab eventKey={2} title="Dettagli" activeKey={activeTab} >

                      <Box
                        component="form"
                        sx={{ '& > :not(style)': { m: 1 } }}
                        noValidate
                        autoComplete="off"
                      >
                        <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                          Necessari
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          I cookie necessari contribuiscono a rendere fruibile il sito web abilitandone funzionalità di base quali la navigazione sulle pagine e l'accesso alle aree protette del sito. Il sito web non è in grado di funzionare correttamente senza questi cookie.
                          I cookie di preferenza consentono al sito web di memorizzare informazioni che ne influenzano il comportamento o l'aspetto, quali la lingua preferita o la località nella quale ti trovi.
                        </Typography>

                        <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                          Analitici
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          I cookie statistici aiutano i proprietari del sito web a capire come i visitatori interagiscono con i siti raccogliendo e trasmettendo relative informazioni.
                        </Typography>

                        <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                          Profilazione
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          I cookie di marketing vengono utilizzati per tracciare i visitatori sui siti web. La finalità è quella di presentare annunci pubblicitari che siano rilevanti e coinvolgenti per il singolo utente e quindi di maggior valore per editori e inserzionisti di terze parti.
                        </Typography>

                        <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                          Non classificati
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          I cookie non classificati sono i cookie che sono in fase di classificazione, insieme ai fornitori di cookie individuali.
                        </Typography>

                      </Box>

                    </Tab>

                    <Tab eventKey={3} title="Informazioni">

                    <Box
                        component="form"
                        sx={{ '& > :not(style)': { m: 1 } }}
                        noValidate
                        autoComplete="off"
                      >

                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          I cookie sono piccoli file di testo che possono essere installati sui siti web per rendere più efficiente l'esperienza per l'utente.
                        </Typography>

                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          La normativa vigente in materia di cookie afferma che possiamo memorizzare i cookie sul tuo dispositivo solo se sono strettamente necessari per il funzionamento del sito stesso. Per tutti gli altri tipi di cookie abbiamo bisogno del tuo consenso.
                        </Typography>

                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          Questo sito utilizza infatti diversi tipi di cookie, alcuni dei quali sono collocati da servizi di terzi che compaiono sulle nostre pagine.
                        </Typography>

                        <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                          In qualsiasi momento potrai modificare o revocare il tuo consenso accedendo ad un'apposita piattaforma per la gestione dei cookie (CMP: Consent Management Platform), sviluppata in conformità ai principi della normativa vigente sul trattamento dei dati personali, direttamente dalla cookie policy (per IT: cookie policy linkabile) dove potrai anche scoprire di più su chi siamo, come poter contattarci e come trattiamo i dati personali.
                        </Typography>

                      </Box>

                    </Tab>
    
                </Tabs>

            </Modal.Body>

            <Modal.Footer>

              <Row> 
                <Col md={12}>
                  <FormControlLabel 
                    control={<Switch defaultChecked />} 
                    checked={isCookiesNecessari} 
                    onChange={switchCookieNecessariHandler} 
                    label="necessari" 
                    disabled
                  />           

                  <FormControlLabel 
                    control={<Switch defaultChecked />} 
                    checked={isCookiesFunzionali} 
                    onChange={switchCookieFunzionaliHandler} 
                    label="funzionali" 
                  />           

                  <FormControlLabel 
                    control={<Switch defaultChecked />} 
                    checked={isCookiesAnalitici} 
                    onChange={switchCookieAnaliticiHandler} 
                    label="analitici" 
                  />           

                  <FormControlLabel 
                    control={<Switch defaultChecked />} 
                    checked={isCookiesProfilazione} 
                    onChange={switchCookieProfilazioneHandler} 
                    label="profilazione" 
                  />           

                </Col>
              </Row>


              <Row className="justify-content-right"> 
                <Col md={12}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModalAppuntamento}
                style={{
                  marginRight: "1ch",
                }}>              
                Accetta
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModalAppuntamento}
                style={{
                  marginRight: "1ch",
                }}>              
                Accetta selezionati
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModalAppuntamento}
                style={{
                  marginRight: "1ch",
                }}>              
                Chiudi e accetta necessari
              </button>
              </Col>
              </Row>



            {/* 
              <button
                  type="button"
                  className="btn btn-danger"
                  onClick={(e) => { }}
                  >
                  Cancella
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => { }}
              >
                Prenotazione
              </button>
            */}

            </Modal.Footer>

        </Modal.Dialog>

      </div>
      <div className={`background`} />
    </div>,
    modalAppuntamento
  );
};

export default ModalAppuntamento;
